<app-base-card [cardTitle]="'WALLET.DETAILS.COMPOSITION' | transloco" contentClasses="w-full h-80 p-0 flex justify-center items-center">
    <div [hidden]="!this.userProductWalletCoinDetails || busy" class="w-full h-80" #compositionChart></div>
    <ion-label [hidden]="this.userProductWalletCoinDetails || busy" class="py-16">{{ "WALLET.DETAILS.EMPTY" | transloco }}</ion-label>
    <ion-spinner [hidden]="!busy" class="py-16 ml-2"></ion-spinner>
</app-base-card>
